module.exports = __webpack_public_path__ + "img/saomaqiang.b084e7aa.png";